import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/lucide-react@1.46.0_react@19.3.0/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.4.2_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.5.1_babel-plugin_e555e45d7cd24a1277f97b608695002e/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/node_modules/.pnpm/next@16.4.2_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.5.1_babel-plugin_e555e45d7cd24a1277f97b608695002e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.4.2_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.5.1_babel-plugin_e555e45d7cd24a1277f97b608695002e/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.4.2_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.5.1_babel-plugin_e555e45d7cd24a1277f97b608695002e/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/core/header/BackButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/core/markdown/plugins/remark-youtube.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/core/navigation/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pages/alternatives/AlternativeLandingCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pages/alternatives/AlternativeTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pages/alternatives/DatadogOfferHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/pages/alternatives/featureTooltip.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/accordion/AccordionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/content/BlockHashtagHeading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/content/BlockQuote.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/content/code/InlineCodeMark.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/content/code/LazyCodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextFlip"] */ "/vercel/path0/src/components/shared/content/TextFlip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/cta/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/cta/CtaSectionGrayBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/customer-reviews/CustomerReviewsSlider.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/forms/HubspotApiForm.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/media/AutoPlayVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/media/ImageWithLightbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/media/VideoSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/sections/CtaTwoBoxesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/spotlight-dots/SpotlightDotsFooter.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/shared/trusted-by/TrustedByLogos.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/tag.tsx");
